export default function R3Slogan() {
    return (
        <svg width="321" height="62" viewBox="0 0 321 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M320.999 0.142578H53.8523C47.7886 0.142578 42.0026 2.36471 37.9515 6.26278L0.0341797 42.6548H320.999L304.786 21.3987L320.999 0.142578Z"
                fill="url(#paint0_linear_1659_26101)"
            />
            <path
                d="M320.999 0.142578H53.8523C47.7886 0.142578 42.0026 2.36471 37.9515 6.26278L0.0341797 42.6548H320.999L304.786 21.3987L320.999 0.142578Z"
                fill="url(#paint1_linear_1659_26101)"
            />
            <path
                d="M320.999 0.142578H53.8523C47.7886 0.142578 42.0026 2.36471 37.9515 6.26278L0.0341797 42.6548H320.999L304.786 21.3987L320.999 0.142578Z"
                fill="url(#paint2_linear_1659_26101)"
            />
            <path
                style={{ mixBlendMode: 'screen' }}
                d="M173.633 0.142578H53.8523C47.7886 0.142578 42.0026 2.36471 37.9515 6.26278L0.0341797 42.6548H1.63901L37.9428 7.80405C41.9939 3.91346 47.7799 1.68385 53.8436 1.68385H319.82L320.999 0.142578L173.633 0.142578Z"
                fill="url(#paint3_linear_1659_26101)"
            />
            <path
                style={{ mixBlendMode: 'multiply' }}
                d="M53.93 0.164062C53.5049 0.164062 53.0799 0.164062 52.6548 0.164062C47.0249 0.433411 41.7333 2.61065 37.9424 6.25434L11.1548 31.9846C10.5736 35.5909 10.5563 39.2121 11.0854 42.6613H58.3628C50.3647 26.3507 42.6962 5.09464 53.93 0.164062Z"
                fill="url(#paint4_linear_1659_26101)"
            />
            <path
                d="M51.4757 56.8106L23.2134 46.5379L2.43738 61.1426C2.43738 61.1426 -0.355882 45.9842 0.0344809 40.904C1.38774 23.531 21.3743 0.142578 53.8526 0.142578C33.224 7.81902 51.4843 56.8106 51.4843 56.8106H51.4757Z"
                fill="url(#paint5_linear_1659_26101)"
            />
            <path
                d="M51.4757 56.8106L23.2134 46.5379L2.43738 61.1426C2.43738 61.1426 -0.355882 45.9842 0.0344809 40.904C1.38774 23.531 21.3743 0.142578 53.8526 0.142578C33.224 7.81902 51.4843 56.8106 51.4843 56.8106H51.4757Z"
                fill="url(#paint6_linear_1659_26101)"
            />
            <path
                style={{ mixBlendMode: 'screen' }}
                d="M51.4757 56.8106L23.2134 46.5379L2.43738 61.1426C2.43738 61.1426 -0.355882 45.9842 0.0344809 40.904C1.38774 23.531 21.3743 0.142578 53.8526 0.142578C33.224 7.81902 51.4843 56.8106 51.4843 56.8106H51.4757Z"
                fill="url(#paint7_linear_1659_26101)"
            />
            <defs>
                <linearGradient id="paint0_linear_1659_26101" x1="30.5346" y1="39.0261" x2="342.293" y2="-8.27291" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#CE8736" />
                    <stop offset="0.53" stopColor="#FBCA1B" />
                    <stop offset="1" stopColor="#FACD7B" />
                </linearGradient>
                <linearGradient id="paint1_linear_1659_26101" x1="30.5346" y1="39.0261" x2="342.293" y2="-8.27291" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#CE8736" />
                    <stop offset="0.53" stopColor="#FBCA1B" />
                    <stop offset="1" stopColor="#FACD7B" />
                </linearGradient>
                <linearGradient id="paint2_linear_1659_26101" x1="8.49205" y1="-19.894" x2="856.626" y2="160.804" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#B48738" />
                    <stop offset="0.02" stopColor="#CAA963" />
                    <stop offset="0.04" stopColor="#DDC587" />
                    <stop offset="0.06" stopColor="#ECDBA3" />
                    <stop offset="0.07" stopColor="#F6EBB7" />
                    <stop offset="0.09" stopColor="#FCF4C3" />
                    <stop offset="0.11" stopColor="#FFF8C7" />
                    <stop offset="0.133665" stopColor="#FEF6C2" />
                    <stop offset="0.177783" stopColor="#FFFCEA" />
                    <stop offset="0.219566" stopColor="#FCF0B3" />
                    <stop offset="0.248951" stopColor="#FAE89C" />
                    <stop offset="0.28" stopColor="#F6DB7C" />
                    <stop offset="0.29" stopColor="#F5D76F" />
                    <stop offset="0.3" stopColor="#F0D06B" />
                    <stop offset="0.383883" stopColor="#D89130" />
                    <stop offset="0.41" stopColor="#B1823A" />
                    <stop offset="0.43" stopColor="#A87733" />
                    <stop offset="0.526116" stopColor="#B0713C" />
                    <stop offset="0.62" stopColor="#AE7B33" />
                    <stop offset="0.69" stopColor="#D69D48" />
                    <stop offset="0.71" stopColor="#C18D41" />
                    <stop offset="0.79" stopColor="#6E4B25" />
                    <stop offset="0.82" stopColor="#4E321A" />
                    <stop offset="0.9" stopColor="#7B521F" />
                    <stop offset="0.93" stopColor="#8D5F22" />
                    <stop offset="1" stopColor="#D69D48" />
                </linearGradient>
                <linearGradient id="paint3_linear_1659_26101" x1="117.542" y1="13.4903" x2="192.601" y2="-5.12766" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="0.52" stopColor="#FACD7B" />
                    <stop offset="0.57" stopColor="#EAC073" />
                    <stop offset="0.66" stopColor="#C29F5F" />
                    <stop offset="0.78" stopColor="#816A3F" />
                    <stop offset="0.93" stopColor="#282114" />
                    <stop offset="1" />
                </linearGradient>
                <linearGradient id="paint4_linear_1659_26101" x1="10.7038" y1="21.4127" x2="58.3541" y2="21.4127" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#CE7C28" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_1659_26101" x1="18.156" y1="9.61467" x2="33.3106" y2="52.5082" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#CE8736" />
                    <stop offset="0.53" stopColor="#FBCA1B" />
                    <stop offset="1" stopColor="#FACD7B" />
                </linearGradient>
                <linearGradient id="paint6_linear_1659_26101" x1="41.1527" y1="-48.4524" x2="18.2073" y2="146.019" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#B48738" />
                    <stop offset="0.02" stopColor="#CAA963" />
                    <stop offset="0.04" stopColor="#DDC587" />
                    <stop offset="0.06" stopColor="#ECDBA3" />
                    <stop offset="0.07" stopColor="#F6EBB7" />
                    <stop offset="0.09" stopColor="#FCF4C3" />
                    <stop offset="0.11" stopColor="#FFF8C7" />
                    <stop offset="0.14" stopColor="#FEF6C2" />
                    <stop offset="0.19" stopColor="#FCF0B3" />
                    <stop offset="0.23" stopColor="#FAE89C" />
                    <stop offset="0.28" stopColor="#F6DB7C" />
                    <stop offset="0.29" stopColor="#F5D76F" />
                    <stop offset="0.3" stopColor="#F0D06B" />
                    <stop offset="0.36" stopColor="#EEBB53" />
                    <stop offset="0.522189" stopColor="#D89130" />
                    <stop offset="0.62" stopColor="#AE7B33" />
                    <stop offset="0.69" stopColor="#D69D48" />
                    <stop offset="0.71" stopColor="#C18D41" />
                    <stop offset="0.79" stopColor="#6E4B25" />
                    <stop offset="0.82" stopColor="#4E321A" />
                    <stop offset="0.9" stopColor="#7B521F" />
                    <stop offset="0.93" stopColor="#8D5F22" />
                    <stop offset="1" stopColor="#D69D48" />
                </linearGradient>
                <linearGradient id="paint7_linear_1659_26101" x1="13.3415" y1="-25.3932" x2="29.6938" y2="57.8248" gradientUnits="userSpaceOnUse">
                    <stop offset="0.34" />
                    <stop offset="0.59" stopColor="#FAF29E" />
                    <stop offset="0.61" stopColor="#EAE394" />
                    <stop offset="0.65" stopColor="#C2BC7A" />
                    <stop offset="0.7" stopColor="#817D51" />
                    <stop offset="0.77" stopColor="#282719" />
                    <stop offset="0.79" />
                </linearGradient>
            </defs>
        </svg>
    );
}
